import { PencilLine } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const EditIcon = DeckardIconWrapper({ Icon: PencilLine });
